<template lang="pug">

div(
  class="alert alert-warning text-center"
  v-if="auditData.manualReviewRequired && auditData.advertiser && auditData.advertiser.cannotAudit"
)
  div( v-if="auditData.batch.standDownMrAs" )
    | MR(AS) settings exist for this advertiser but have not been applied to this audit
  div( v-else )
    | This link is in #[strong Manual Review] on the basis of being identified as exhibiting:&nbsp;
    strong {{ auditData.advertiser.cannotAuditReason }}
  
  div( v-if="auditData.injectedResult" )
    | Moonpull's own #[strong Guided Result] for {{ getPublisherTypeString() }} publisher&nbsp;
    | conducted on {{ dateFormat(auditData.injectedResult.template.createdAt, 'dS mmmm yyyy') }} is: #[strong {{ auditData.injectedResult.template.readableStatus }}].

</template>

<script>
import dateFormat from 'dateformat'
export default {
  props: {
    auditData: {
      type: Object,
      required: true
    }
  },
  methods: {
    dateFormat,
    getIndefiniteArticle(word) {
      return ['a', 'e', 'i', 'o', 'u'].includes(word[0].toLowerCase()) ? 'an' : 'a'
    },
    getPublisherTypeString() {
      const pt = this.auditData.injectedResult.template.readablePublisherType
      return `${this.getIndefiniteArticle(pt)} ${pt}`
    },
  },
}
</script>
